import { Grid, Input, Label, Stack } from '@careflux/primitives';
import { FilterSelect } from './FilterSelect';
import type { AudioQualityFilterBarProps } from './audioQuality.types';
import { MODE_OPTIONS } from './formatting';
import type { SummaryMode } from './types';

export const AudioQualityFilterBar = ({
  filters,
  orgOptions,
  scorerVersions,
  scorerVersion,
  onFilterChange,
  onScorerVersionChange,
}: AudioQualityFilterBarProps) => {
  const versions =
    scorerVersion && !scorerVersions.includes(scorerVersion) ? [...scorerVersions, scorerVersion] : scorerVersions;
  const orgs =
    filters.orgId && !orgOptions.some((option) => option.value === filters.orgId)
      ? [...orgOptions, { value: filters.orgId, label: 'Valin stofnun' }]
      : orgOptions;
  return (
    <Grid columns={{ base: 1, md: 2, xl: 5 }} gap="md" className="rounded-md border p-4">
      <Stack gap="xs">
        <Label htmlFor="audio-quality-from">Frá</Label>
        <Input
          id="audio-quality-from"
          type="date"
          value={filters.from}
          onChange={(event) => onFilterChange({ from: event.target.value })}
        />
      </Stack>
      <Stack gap="xs">
        <Label htmlFor="audio-quality-to">Til</Label>
        <Input
          id="audio-quality-to"
          type="date"
          value={filters.to}
          onChange={(event) => onFilterChange({ to: event.target.value })}
        />
      </Stack>
      <FilterSelect
        id="audio-quality-org"
        label="Stofnun"
        allLabel="Allar stofnanir"
        value={filters.orgId}
        options={orgs}
        onChange={(orgId) => onFilterChange({ orgId })}
      />
      <FilterSelect
        id="audio-quality-mode"
        label="Tegund"
        allLabel="Allar tegundir"
        value={filters.mode}
        options={MODE_OPTIONS}
        onChange={(mode) => onFilterChange({ mode: mode as SummaryMode | null })}
      />
      <FilterSelect
        id="audio-quality-version"
        label="Útgáfa hljóðmats"
        allLabel="Nýjasta útgáfa á tímabilinu"
        value={scorerVersion}
        options={versions.map((version) => ({ value: version, label: version }))}
        onChange={onScorerVersionChange}
      />
    </Grid>
  );
};
